module.exports = __webpack_public_path__ + "static/media/200009_resultaat.50de8c42.jpg";